module.exports = __webpack_public_path__ + "static/img/it2_en.902a75a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/it2_en.png
// module id = ZTp/
// module chunks = 0